import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../../../../../../../Stylesheets/Dashboard/Tabs/Materials/ViewMaterialDrawer.css';
import { FaPen } from 'react-icons/fa'
import { RiDeleteBinLine } from 'react-icons/ri';
import { RxCross2 } from 'react-icons/rx';

import { editMaterialDetails, clearMaterialSubmitState } from '../../../../../../../Redux/Projects/Material/materialSlice';
import { toast } from 'react-toastify';

const ViewMaterialDrawer = ({ projectId,material, onClose, onLogMoreUsage, onUploadAnotherBill, onViewFullLog, onDelete, onRestore }) => {




    const dispatch = useDispatch();
    const materialState = useSelector((state) => state.materials);




    useEffect(() => {
        if (material) {
            setEditedFields({
                name: material.name || '',
                unit: material.unit || '',
                minThreshold: material.minThreshold || '',
                vendor: material.vendor || '',
                location: material.location || '',
                rate: material.rate || '',
            });
        }
    }, [material]);

    const [sortField, setSortField] = useState('date'); // or 'status', 'amount'
    const [sortAsc, setSortAsc] = useState(false); // descending default
    const [isEditing, setIsEditing] = useState(false);
    // const [editedFields, setEditedFields] = useState({
    //     name: material?.name,
    //     unit: material?.unit,
    //     minThreshold: material?.minThreshold,
    //     vendor: material?.vendor,
    //     location: material?.location,
    //     rate: material?.rate,
    // });
    const [editedFields, setEditedFields] = useState({});
    if (!material) return null;




    const inStock = material.received - material.used;
    const isLowStock = inStock <= (material.minThreshold || 0);


    const sortedBills = [...(material.billHistory || [])].sort((a, b) => {
        if (sortField === 'status') {
            return (a.status === 'Pending' ? -1 : 1) - (b.status === 'Pending' ? -1 : 1);
        }
        if (sortField === 'amount') {
            return sortAsc ? a.amount - b.amount : b.amount - a.amount;
        }
        if (sortField === 'quantity') {
            return sortAsc ? a.quantity - b.quantity : b.quantity - a.quantity;
        }
        // default: sort by date
        return sortAsc
            ? new Date(a.date) - new Date(b.date)
            : new Date(b.date) - new Date(a.date);
    });


    const handleFieldChange = (field, value) => {
        setEditedFields(prev => ({ ...prev, [field]: value }));
    };

    const handleCancelEdit = () => {
        setIsEditing(false);
        setEditedFields({
            name: material?.name,
            unit: material?.unit,
            minThreshold: material?.minThreshold,
            vendor: material?.vendor,
            location: material?.location,
            rate: material?.rate,
        });
    };

    const handleSaveEdit = async () => {
        try {
            await dispatch(editMaterialDetails({ materialId: material._id, updates: editedFields,projectId:projectId })).unwrap();
            toast.success('✅ Material details updated successfully');
            setIsEditing(false);
            dispatch(clearMaterialSubmitState());
        } catch (err) {
            toast.error(err || '❌ Failed to update material');
        }
    };



    return (
        <div className="drawer-overlay">
            <div className="drawer">
                <div className="drawer-header">
                    <h3 className="drawer-title">{material?.name}</h3>

                    <div className="drawer-actions">
                        {!!onDelete && (
                            <button
                                type="button"
                                className="icon-btn icon-btn--danger"
                                onClick={() => onDelete(material)}
                                aria-label="Delete material"
                                title="Delete material"
                            >
                                <RiDeleteBinLine size={18} />
                            </button>
                        )}

                        <button
                            type="button"
                            className="icon-btn icon-btn--ghost"
                            onClick={onClose}
                            aria-label="Close"
                            title="Close"
                        >
                            <RxCross2 size={18} />
                        </button>
                    </div>
                </div>


                {/* Section: Material Info */}
                <div className="drawer-section">
                    <div className='drawer-material-info-header-sec'>
                        <h4 className="section-title">Material Info</h4>
                        {!isEditing ? (
                            <button className="edit-btn-dra" onClick={() => setIsEditing(true)}>Edit</button>
                        ) : (
                            <button className="cancel-btn-dra" onClick={handleCancelEdit}>Cancel</button>
                        )}
                    </div>

                    <table className="drawer-table info-table">
                        <thead>
                            <tr>
                                <th>Field</th>
                                <th>Value shown</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Material Name</td>
                                <td>
                                    {isEditing ? (
                                        <input
                                            value={editedFields?.name}
                                            onChange={(e) => handleFieldChange('name', e.target.value)}
                                        />
                                    ) : (
                                        <>
                                            <strong>{material?.name}</strong>
                                        </>
                                    )}
                                    {/* <span className="edit-icon"><FaPen /></span> */}
                                </td>
                            </tr>
                            <tr>
                                <td>Unit</td>
                                <td>
                                    {isEditing ? (
                                        <input
                                            value={editedFields?.unit}
                                            onChange={(e) => handleFieldChange('unit', e.target.value)}
                                        />
                                    ) : (
                                        <>
                                            <strong>{material?.unit}</strong>
                                        </>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td>Total Received</td>
                                <td><strong>{material?.received}</strong></td>
                            </tr>
                            <tr>
                                <td>Total Used</td>
                                <td><strong>{material?.used}</strong></td>
                            </tr>
                            <tr>
                                <td>In Stock</td>
                                <td>
                                    <strong>{inStock}</strong>
                                    {isLowStock && <span className="low-stock-tag">Low Stock</span>}
                                </td>
                            </tr>
                            <tr>
                                <td>Min Threshold</td>
                                <td>
                                    {isEditing ? (
                                        <input
                                            value={editedFields?.minThreshold}
                                            onChange={(e) => handleFieldChange('minThreshold', e.target.value)}
                                        />
                                    ) : (
                                        <>
                                            <strong>{material?.minThreshold || '-'}</strong>
                                        </>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td>Vendor</td>
                                <td>
                                    {isEditing ? (
                                        <input
                                            value={editedFields?.vendor}
                                            onChange={(e) => handleFieldChange('vendor', e.target.value)}
                                        />
                                    ) : (
                                        <>
                                            <strong>{material?.vendor || '-'}</strong>
                                        </>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td>Storage Location</td>
                                <td>
                                    {isEditing ? (
                                        <input
                                            value={editedFields?.location}
                                            onChange={(e) => handleFieldChange('location', e.target.value)}
                                        />
                                    ) : (
                                        <>
                                            <strong>{material?.location || '-'}</strong>
                                        </>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td>Rate per Unit</td>
                                <td>
                                    {isEditing ? (
                                        <input
                                            value={editedFields?.rate}
                                            onChange={(e) => handleFieldChange('rate', e.target.value)}
                                        />
                                    ) : (
                                        <>
                                            <strong>₹{material?.rate?.toLocaleString() || '-'}</strong>
                                        </>
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {isEditing && (
                        <button
                            className="material-edit-save-btn"
                            onClick={handleSaveEdit}
                            disabled={materialState?.submitting} // ✅ prevents double submits
                        >
                            {materialState?.submitting ? 'Saving...' : 'Save Details'}
                        </button>
                    )}
                </div>




                {/* Section: Usage History */}
                {/* Usage History Section */}
                <div className="drawer-section">
                    <div className="drawer-section-header">
                        <h4>Usage History</h4>
                        <button className="drawer-log-more" onClick={() => onLogMoreUsage(material)}>Log More Usage</button>
                    </div>
                    <table className="drawer-table usage-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Used Qty</th>
                                <th>Used For</th>
                                <th>By</th>
                                <th>Notes</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(material.usageHistory || []).slice(0, 3).map((item, index) => (
                                <tr key={index}>
                                    <td>{new Date(item.date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}</td>
                                    <td style={{ fontWeight: '600' }}>{item.quantity}</td>
                                    <td className="truncate">{item.usedFor || '-'}</td>
                                    <td>{item.usedBy || item.createdBy /* later replace with createdByName */ || '-'}</td>
                                    <td className="truncate">{item.notes || '-'}</td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                    <button className="drawer-view-log-btn" onClick={() => onViewFullLog(material)}>View full log</button>
                </div>


                {/* Section: Bill History */}
                {/* Section: Bill History */}
                <div className="drawer-section">
                    <div className="drawer-section-header">
                        <h4>Bill History</h4>
                        <div className="bill-sort-container">
                            <span className="bill-sort-label">Sort by</span>
                            <select
                                value={sortField}
                                onChange={(e) => setSortField(e.target.value)}
                                className="bill-sort-dropdown"
                            >
                                <option value="date">Date</option>
                                <option value="status">Status</option>
                                <option value="amount">Amount</option>
                                <option value="quantity">Quantity</option>
                            </select>
                            <button
                                className="bill-sort-dir"
                                onClick={() => setSortAsc((s) => !s)}
                                title="Toggle ascending/descending"
                            >
                                {sortAsc ? '▲' : '▼'}
                            </button>
                        </div>
                    </div>

                    {/** compute a sorted copy here so the rest of the drawer can keep its state logic simple */}
                    {(() => {
                        const statusWeight = (st) => {
                            // Order: error > processing > uploaded (you can flip by swapping numbers)
                            const map = { error: 2, processing: 1, uploaded: 0, Pending: 1 };
                            // 'Pending' kept as fallback if older data still sends it
                            return map[st] ?? 0;
                        };

                        const bills = [...(material.billHistory || [])].sort((a, b) => {
                            if (sortField === 'status') {
                                const aw = statusWeight(a.status);
                                const bw = statusWeight(b.status);
                                return sortAsc ? aw - bw : bw - aw;
                            }
                            if (sortField === 'amount') {
                                const av = Number(a.amount || 0);
                                const bv = Number(b.amount || 0);
                                return sortAsc ? av - bv : bv - av;
                            }
                            if (sortField === 'quantity') {
                                const aq = Number(a.quantity || 0);
                                const bq = Number(b.quantity || 0);
                                return sortAsc ? aq - bq : bq - aq;
                            }
                            // default: date
                            const ad = new Date(a.billedDate || a.date || 0).getTime();
                            const bd = new Date(b.billedDate || b.date || 0).getTime();
                            return sortAsc ? ad - bd : bd - ad;
                        });

                        const renderStatus = (it) => {
                            const st = (it.status || '').toLowerCase();
                            if (st === 'uploaded') {
                                return <span className="drawer-bill-status uploaded">✅ Uploaded</span>;
                            }
                            if (st === 'processing' || st === 'pending') {
                                return (
                                    <span className="drawer-bill-status processing" title="Bill is being linked to receives">
                                        ⏳ Processing
                                    </span>
                                );
                            }
                            if (st === 'error') {
                                return (
                                    <span
                                        className="drawer-bill-status error"
                                        title={it.errorMessage || 'Bill encountered an error while saving'}
                                    >
                                        ❌ Error
                                    </span>
                                );
                            }
                            // Fallback for legacy data that had "Pending"
                            if (it.status === 'Pending') {
                                return <span className="drawer-bill-status processing">⚠ Pending</span>;
                            }
                            return <span className="drawer-bill-status uploaded">—</span>;
                        };

                        return (
                            <table className="drawer-table bill-table">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Qty</th>
                                        <th>Amount</th>
                                        <th>By</th>
                                        <th>File</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bills.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                {new Date(item.billedDate || item.date).toLocaleDateString('en-IN', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric',
                                                })}
                                            </td>
                                            <td style={{ fontWeight: 600 }}>{item.quantity || '-'}</td>
                                            <td>₹{Number(item.amount || 0).toLocaleString('en-IN')}</td>
                                            <td>{item.uploadedByName || item.createdBy || '-'}</td>
                                            <td>
                                                {item.fileUrl ? (
                                                    <a
                                                        className="drawer-view-link"
                                                        href={item.fileUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                ) : (
                                                    '-'
                                                )}
                                            </td>
                                            <td>{renderStatus(item)}</td>
                                        </tr>
                                    ))}
                                    {bills.length === 0 && (
                                        <tr>
                                            <td colSpan={6} style={{ textAlign: 'center', opacity: 0.7 }}>
                                                No bills yet
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        );
                    })()}

                    <button className="drawer-upload-bill-btn" onClick={() => onUploadAnotherBill(material)}>
                        Upload Another Bill
                    </button>
                </div>

            </div >
        </div >
    );
};

export default ViewMaterialDrawer;
